<div>
  <ac-input-container label="Agent type" class="fullWidth">
    <ac-select [acModel]="implementation.numberPortabilityAgentType"
               [searchable]="true"
               (acModelChange)="implementation.numberPortabilityAgentType = $event; agentTypeSelected($event)"
               [items]="numberPortabilityAgentTypes"
               [attr.alternativeName]="'type'"
               [ngDisabled]="isEditMode">
    </ac-select>
  </ac-input-container>

  <form #webServiceFrom="ngForm" autocomplete="off">
    <mat-form-field class="fullWidth">
      <mat-label>name</mat-label>
      <input [(ngModel)]="implementation.name" matInput name="name" required maxlength="255">
    </mat-form-field>

    <div class="web-service-params">
      <div *ngFor="let param of implementation.params"
           [ngClass]="{'fullWidth': (param.type === 'booleanType' || param.displayCondition),
         'column': (param.type === 'stringType' || param.type === 'enumType' || param.type === 'numberType') && !param.displayCondition}">

        <div *ngIf="param.type === 'stringType'">
          <mat-form-field *ngIf="displayField(implementation.params, param)" [title]="param.uiName" class="fullWidth">
            <mat-label>{{param.uiName}}</mat-label>
            <input [(ngModel)]="param.value" matInput [name]="param.name" [required]="param.isRequired">
          </mat-form-field>
        </div>

        <div *ngIf="param.type === 'booleanType'">
          <div *ngIf="displayField(implementation.params, param)" class="arm-checkbox">
            <mat-checkbox [name]="param.name" class="fullWidth"
                          color="primary" [(ngModel)]="param.value">{{param.uiName}}</mat-checkbox>
          </div>
        </div>

        <div *ngIf="param.type === 'numberType'">
          <mat-form-field *ngIf="displayField(implementation.params, param)" [title]="param.uiName" class="fullWidth">
            <mat-label>{{param.uiName}}</mat-label>
            <input type="number" [(ngModel)]="param.value" matInput [name]="param.name"
                   [min]="param.minValue" [max]="param.maxValue" [required]="param.isRequired">
          </mat-form-field>
        </div>

        <div *ngIf="param.type === 'enumType'">
          <ac-input-container label="{{param.uiName}}" *ngIf="displayField(implementation.params, param)"
                              class="fullWidth">
            <ac-select [acModel]="param.value"
                       (acModelChange)="param.value = $event"
                       [items]="param.options"
                       [attr.alternativeName]="param.name">
            </ac-select>
          </ac-input-container>
        </div>
      </div>
    </div>
  </form>
</div>
